import React from 'react';

const PlanButton = ({ planId }) => {
  const handleClick = () => {
    const currentUrl = window.location.href;
    
    // Check if the URL already has a query string. If so, use '&', otherwise use '?'.
    const separator = currentUrl.includes('?') ? '&' : '?';
    
    // Construct the new URL with 'plan' as the query parameter name
    const newUrl = `${currentUrl}${separator}plan=${planId}`;
    
    window.location.href = newUrl;
  };

  return (
    <button type="button" className="chakra-button css-ra00vf" onClick={handleClick}>
      خرید پلن
    </button>
  );
};

export default PlanButton;